/* tslint:disable */
/* eslint-disable */
/**
 * C4 Links Collab Catman API
 * API documentation for C4 Links Collab Catman
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
export const BASE_PATH = 'http://localhost'.replace(/\/+$/, '');
export const COLLECTION_FORMATS = {
  csv: ',',
  ssv: ' ',
  tsv: '\t',
  pipes: '|'
};
export class BaseAPI {
  constructor(configuration, basePath = BASE_PATH, axios = globalAxios) {
    var _a;
    this.basePath = basePath;
    this.axios = axios;
    if (configuration) {
      this.configuration = configuration;
      this.basePath = (_a = configuration.basePath) !== null && _a !== void 0 ? _a : basePath;
    }
  }
}
export class RequiredError extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
    this.name = 'RequiredError';
  }
}
export const operationServerMap = {};
